import { useEffect } from "react";
import useCMS from "./useCMS";

const useCMSColorInitializer = () => {
  const { getCMSByType } = useCMS();
  const colors = getCMSByType("COLORS") as Record<string, string>;

  useEffect(() => {
    if (!colors) return;
    const root = document.documentElement;
    Object.entries(colors).forEach(([key, value]) => [root.style.setProperty(`--${key}`, value)]);
  }, [colors]);

  return null;
};

export default useCMSColorInitializer;
